module.exports = __webpack_public_path__ + "static/media/user4.d6b4d59c.png";